import React from "react";
import { connect } from "react-redux";
import * as Type from "@interface/index";
import { withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";
import { Select } from "@components/form";

interface PropsInterface extends Type.ComponentInterface {
  show: boolean;
  isNetworkingPage?: boolean;
  hide: () => void;
  callback?: (filters: any, viewStatuses: any) => void;
}

interface StateInterface {
  specFilterShow: boolean;
  typeFilterShow: boolean;
  showCompanies: boolean;
  showEmployes: boolean;
  types: number[];
  specializations: number[];
  typesGroupsHided: number[];
  direction: number | null;
  companiesShow: boolean;
  usersShow: boolean;
}

class NetworkingFilterComponent extends React.Component<PropsInterface, StateInterface> {
  public constructor(Props: PropsInterface) {
    super(Props);
    this.state = {
      specFilterShow: true,
      typeFilterShow: true,
      showCompanies: true,
      showEmployes: true,
      types: [],
      specializations: [],
      typesGroupsHided: [],
      direction: null,
      companiesShow: true,
      usersShow: true,
    };
    this.onCheckHandler = this.onCheckHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  public componentDidMount() {
    this.callback();
  }

  private renderItems(Group: any, inGroup: boolean = false) {
    const items: JSX.Element[] = [];
    Group.itemList.map((Item: any, index: number) => {
      items.push(
        <div className={`netw-filter__${inGroup ? "subgroup" : "group"}-item`} key={Item.id}>
          <input
            tabIndex={0}
            className="visually-hidden"
            id={Item.id + "types"}
            type="checkbox"
            name="types"
            value={Item.id}
            checked={this.state.types.includes(Item.id)}
            onChange={this.onCheckHandler}
          />
          <label htmlFor={Item.id + "types"}>
            {Item.name}
            {/* <span>{this.state.types.includes(Item.id) ? "true" : "false"}</span> */}
          </label>
        </div>
      );
    });
    return items;
  }

  private onChangeHandler(
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ): void {
    this.setState({ [event.target.name]: event.target.value }, () => {
      this.callback();
    });
  }

  private onCheckHandler(event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>): void {
    const list = this.state[event.target.name];
    if (list.includes(Number(event.target.value))) {
      list.splice(list.indexOf(Number(event.target.value)), 1);
    } else {
      list.push(Number(event.target.value));
    }
    this.setState({ [event.target.name]: list }, () => {
      this.callback();
    });
  }

  public callback() {
    if (this.props.callback) {
      const filters: any = {};
      if (this.state.specializations.length) {
        filters.specializationList = this.state.specializations;
      }
      if (this.state.types.length) {
        filters.typeList = this.state.types;
      }
      if (this.state.direction) {
        filters.direction = this.state.direction;
      }
      this.props.callback(filters, {
        showUsers: this.state.usersShow,
        showCompanies: this.state.companiesShow,
      });
    }
  }

  public render() {
    return (
      <>
        <div
          className={`netw-filter ${this.props.show ? "" : "netw-filter--closed"} ${
            this.props.isNetworkingPage ? "kek" : ""
          }`}
        >
          <button
            className="netw-filter__close js-filter-trigger"
            type="button"
            onClick={() => this.props.hide()}
          />
          <div className="netw-filter__title">Каталог</div>
          <div className="netw-filter__filter">
            <div className="netw-filter__filter-header">Фильтр:</div>
            <div className="netw-filter__filter-body">
              <div className="netw-filter__filter-item">
                <input
                  className="visually-hidden visually-hidden"
                  id="filter-company"
                  type="checkbox"
                  name="filter-company"
                  checked={this.state.companiesShow}
                />
                <label
                  htmlFor="filter-company"
                  onClick={() =>
                    this.setState({ companiesShow: !this.state.companiesShow }, () =>
                      this.callback()
                    )
                  }
                >
                  Компании
                  <span>{this.props.Store.Networking.Company.count}</span>
                </label>
              </div>
              <div className="netw-filter__filter-item">
                <input
                  className="visually-hidden visually-hidden"
                  id="filter-people"
                  type="checkbox"
                  name="filter-people"
                  checked={this.state.usersShow}
                />
                <label
                  htmlFor="filter-people"
                  onClick={() =>
                    this.setState({ usersShow: !this.state.usersShow }, () => this.callback())
                  }
                >
                  Люди
                  <span>{this.props.Store.Networking.User.count}</span>
                </label>
              </div>
            </div>
          </div>
          <hr />
          <div className="netw-filter__country">
            <Select
              name="direction"
              value={this.state.direction}
              onChange={this.onChangeHandler}
              options={this.props.Store.Company.Direction.list?.filter(
                (Direction: any) => Direction.count > 0
              )}
              required={false}
              placeholder="Направление"
            />
          </div>
          <hr />
          <div className="netw-filter__main">
            <div
              className={`netw-filter__group ${
                this.state.specFilterShow ? "" : "netw-filter__group--closed"
              }`}
            >
              <div
                className="netw-filter__group-header"
                onClick={() => this.setState({ specFilterShow: !this.state.specFilterShow })}
              >
                Специализация:
                <div className="netw-filter__group-arrow" />
              </div>
              <div className="netw-filter__group-body">
                {this.props.Store.Company.Specialization?.list?.map((Item: any, index: number) => {
                  return (
                    <div className="netw-filter__group-item" key={Item.id}>
                      <input
                        className="visually-hidden"
                        id={Item.id + "specializations"}
                        type="checkbox"
                        name="specializations"
                        value={Item.id}
                        checked={this.state.specializations.includes(Item.id)}
                        onChange={this.onCheckHandler}
                      />
                      <label htmlFor={Item.id + "specializations"}>
                        {Item.name} {this.state.specializations.includes(Item.id)}
                        {/* <span>0</span> */}
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
            <hr />
            <div
              className={`netw-filter__group ${
                this.state.typeFilterShow ? "" : "netw-filter__group--closed"
              }`}
            >
              <div
                className="netw-filter__group-header"
                onClick={() => this.setState({ typeFilterShow: !this.state.typeFilterShow })}
              >
                Тип компании:
                <div className="netw-filter__group-arrow" />
              </div>
              <div className="netw-filter__group-body">
                {this.props.Store.Company.Type?.groups.map((Group: any, index: number) => {
                  if (Group.id !== 0) {
                    return (
                      <div
                        className={`netw-filter__subgroup${
                          this.state.typesGroupsHided.includes(Group.id) ? "--closed" : ""
                        }`}
                        key={Group.id}
                      >
                        <div
                          className="netw-filter__subgroup-header"
                          onClick={(e) => {
                            const typesGroupsHided = this.state.typesGroupsHided || [];
                            if (typesGroupsHided.includes(Group.id)) {
                              const i = typesGroupsHided.indexOf(Group.id);
                              typesGroupsHided.splice(i, 1);
                            } else {
                              typesGroupsHided.push(Group.id);
                            }
                            typesGroupsHided.sort((a, b) => a - b);
                            this.setState({ typesGroupsHided });
                          }}
                        >
                          {Group.name}
                          {/* <span>0</span> */}
                          <div className="netw-filter__subgroup-arrow" />
                        </div>
                        <div className="netw-filter__subgroup-body">
                          {this.renderItems(Group, true)}
                        </div>
                      </div>
                    );
                  } else {
                    return this.renderItems(Group);
                  }
                })}
              </div>
            </div>
          </div>
          {/* <button
            className="netw-filter__submit-btn"
            type="submit"
            onClick={() => this.props.hide()}
          >
            Применить фильтр
          </button> */}
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: (action: any) => void) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(NetworkingFilterComponent)
);
